import React, { Component } from 'react';
import L from 'leaflet';
import d3 from 'd3';

// postCSS import of Leaflet's CSS
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-dialog/Leaflet.Dialog.css';
import community from 'json!./data/community.geojson';

var communityList = community.features.map( function(c){
  return c.properties.class_code;
});
communityList.sort();
var crimeTypes =["Assault",
"Commercial Robbery",
"Street Robbery",
"Violence",
"Residential Break & Enter",
"Commercial Break & Enter",
"Theft OF Vehicle",
"Theft FROM Vehicle",
"Social Disorder",
"Physical Disorder"
];
var yearList =   [2012,2013,2014,2015,2016,2017];
var comm_color = d3.scale.quantile()
            .range(["#fff7ec","#fee8c8","#fdd49e","#fdbb84","#fc8d59","#ef6548","#d7301f","#b30000","#7f0000"]);

// store the map configuration properties in an object,
let config = {};
config.params = {
  zoomControl: false,
  zoom: 13,
  maxZoom: 19,
  minZoom: 4,
  scrollwheel: false,
  legends: true,
  infoControl: false,
  attributionControl: true
};
config.tileLayer = {
  uri: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
  params: {
    minZoom: 4,
    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="http://cartodb.com/attributions">CartoDB</a>',
    id: '',
    accessToken: ''
  }
};

// array to store unique names of Brooklyn subway lines,
// this eventually gets passed down to the Filter component

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      map: null,
      tileLayer: null,
      communityLayer: null,
      community: null,
      show: false,
      content: "",
      legend: null,
      crimeType:"",
      crimeTypes:crimeTypes,
      legendCategories:null,
      moved:false,
      year:2012,
      perCapita: false
    };
    this._mapNode = null;
    this.updateMap = this.updateMap.bind(this);
    this.onEachCommunityFeature = this.onEachCommunityFeature.bind(this);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.updateData = this.updateData.bind(this);
    this.updateLegend = this.updateLegend.bind(this);
    this.communitystyle = this.communitystyle.bind(this);
    this.communityChart =   this.communityChart.bind(this);
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentDidMount() {
    // code to run just after the component "mounts" / DOM elements are created
    this.setState({crimeType:"Assault"});

    this.getData();
    // create the Leaflet map object
    if (!this.state.map) this.init(this._mapNode);
  }

  componentDidUpdate(prevProps, prevState) {
    // code to run when the component receives new props or state
    if (this.state.community && this.state.map && !this.state.communityLayer) {
      this.addCommunityJSONLayer(this.state.community);
      this.updateLegend();
    }

  }

  componentWillUnmount() {
    // code to run just before unmounting the component
    // this destroys the Leaflet map object & related event listeners
    this.state.map.remove();
  }

  getData() {
    var parent = this;

    d3.csv("CrimeStatistics.csv",function(err, crimes){
      community.features.forEach(function(comm){
        crimes.forEach(function (cr){
          if( comm.properties.name===cr.Community){
            comm.properties[cr.Category] = cr;
          }
        });
      });

      d3.csv("Populations.csv",function(err, population){
        community.features.forEach(function(comm){
          comm.properties.population = {};
          population.forEach(function (pop){
            if( comm.properties.name===pop.name){
              var year = pop.census_year.split(" ")[0];
              year =year.split("/")[2];
              comm.properties.population[year] = parseFloat(pop.population.replace(/,/g, ""));
            }
          });
        });
        parent.updateData();
      });
    });
  }
  updateMap(e) { }
  updateData(){
    var parent = this;
    var rates =[];

    community.features.forEach(function(comm){
      comm.properties.rate = crimeCount( comm, parent.state.crimeType,parent.state.year );
      if( parent.state.perCapita){
        if( comm.properties.population && comm.properties.population[parent.state.year] > 0 ){
          comm.properties.rate /= comm.properties.population[parent.state.year];
        }else{
          comm.properties.rate  = 0;
        }
      }
      if( comm.properties.rate> 0 )
        rates.push(comm.properties.rate );
    });
    this.setState({legendCategories:rates});
    comm_color.domain( rates);
    if( this.state.communityLayer){
      this.state.map.removeLayer(this.state.communityLayer);
      this.setState({ communityLayer:null });
    }
    this.setState({
      community
    });
  }
  updateLegend(){
    if( this.state.legend){
      this.state.legend.remove();
    }
    var legend = L.control({position: 'bottomright'});
    var parent = this;
    legend.onAdd = function (map) {
      var div = L.DomUtil.create('div', 'info legend'),
        grades = comm_color.quantiles();
      var pop = parent.state.perCapita ? "/pop " : " ";
      div.innerHTML += "<h3>"+parent.state.crimeType+pop+parent.state.year+"</h3>";
      var table =   "<table>";
      for (var i = 0; i < grades.length; i++) {
        table +=
            "<tr><td><i style='background:" + comm_color(grades[i] ) + "'></i> " +
            "</td><td>"+grades[i].toFixed(3);
            table+=(i === grades.length-1) ? " + ":"";
            table +=  "</td></tr>" ;
      }
      table += "</table>";
      div.innerHTML += table;
      return div;
    };
    this.setState({
      legend
    });
    legend.addTo(this.state.map);
  }

  addCommunityJSONLayer(geojson) {
    const communityLayer = L.geoJson(geojson, {
      onEachFeature: this.onEachCommunityFeature,
      style:this.communitystyle
    });
    communityLayer.addTo(this.state.map);
    this.setState({ communityLayer });
    if( !this.state.moved ){
      this.setState({moved:true});
      this.zoomToFeature(communityLayer);

    }

  }

  zoomToFeature(target) {
    // pad fitBounds() so features aren't hidden under the Filter UI element
    var fitBoundsParams = {
      paddingTopLeft: [200,10],
      paddingBottomRight: [10,10]
    };
    // set the map's center & zoom so that it fits the geographic extent of the layer
    this.state.map.fitBounds(target.getBounds(), fitBoundsParams);
  }

  onEachCommunityFeature(feature, layer) {
    layer.on({
      click: this.communityChart
    });
      // assemble the HTML for the markers' popups (Leaflet's bindPopup method doesn't accept React JSX)
    const popupContent = `<h3>${feature.properties.name}</h3><strong>Population: </strong>${feature.properties.population[this.state.year]}  <strong>${this.state.crimeType}: </strong>${feature.properties.rate}<br>`;
      // add our popups
    layer.bindPopup(popupContent);
  }

  communityChart(e){
    var crimeIndex ;
    for( var ci = 0; ci < this.state.crimeTypes.length; ci++){
      if( this.state.crimeType === this.state.crimeTypes[ci])
        crimeIndex = ci;
    }
    var feature = e.target.feature;
    var width = 200, height = 100;
    var x = d3.scale.linear()
            .range([0, width]);

    var y = d3.scale.linear()
            .range([height, 0]);
    var z = d3.scale.category10();

    var xAxis = d3.svg.axis()
            .scale(x)
            .orient("bottom");

    var yAxis = d3.svg.axis()
            .scale(y)
            .orient("left");

    var ybase;
    var line = d3.svg.line()
            .x(function(d, i) { return x(i); })
            .y(function(d,i) {
              if( i ===0){
                ybase = d;
                if(ybase ===0) ybase =1 ;
              }
              return y(d/ybase);
            });

    var keys = Object.values(feature.properties.population);
    var values = Object.values(feature.properties.population);
// generate an array of yearly totals for each crime Category
    var crimes = crimeTypes.map( function(crimeType){
      return yearList.map(function(year){
        return crimeCount( feature, crimeType, year );
      });
    });
    x.domain(d3.extent(values, function(d, i) { return i; }));
    y.domain([
      d3.min(crimes, function(c) {
        var base;
        return d3.min(c, function(d, i) {
          if( i === 0){
            base = d;
            if( base === 0) base = 1;
          }
          return d/base; });
      }),
      d3.max(crimes, function(c) {
        var base;
        return d3.max(c, function(d,i) {
          if( i === 0){
            base = d;
            if( base === 0) base = 1;
          }
          return d/base; });  })
    ]);
    d3.select(".popupchart").select("svg").remove();
    d3.select(".popupchart").select("H3").text(feature.properties.name);

    var chart = d3.select(".popupchart").append("svg");
    var crime = chart.selectAll(".crime")
        .data(crimes)
        .enter().append("g")
          .attr("class", "crime");

    crime.append("path")
          .attr("class", "line")
          .attr("d", function(d) { return line(d); })
          .attr("fill", "none")
          .attr("stroke", function(d,i){ return z(i);})
          .attr("stroke-linejoin", "round")
          .attr("stroke-linecap", "round")
          .attr("stroke-width", function(d, i){
            if( i === crimeIndex)
              return 3.0;
            return 1.0;
          });

          // Add the X Axis
/*    chart.append("g")
                  .attr("class", "x axis")
                  .attr("transform", "translate(0," + height + ")")
                  .call(xAxis);
  */
              // Add the Y Axis
    chart.append("g")
                  .attr("class", "y axis")
                  .call(yAxis);
  }

  init(id) {
    if (this.state.map) return;
    // this function creates the Leaflet map object and is called after the Map component mounts
    let map = L.map(id, config.params);
    L.control.zoom({ position: "bottomleft"}).addTo(map);
    L.control.scale({ position: "bottomleft"}).addTo(map);

    // a TileLayer is used as the "basemap"
    const tileLayer = L.tileLayer(config.tileLayer.uri, config.tileLayer.params).addTo(map);

    // set our state to include the tile layer
    this.setState({ map, tileLayer });

    var selector = L.control({
      position: 'topright'
    });
    var parent = this;
    selector.onAdd = function(map) {
  //create div container
      var div = L.DomUtil.create('div', 'mySelector');
  //create select element within container (with id, so it can be populated later)
      var select = '<select id="marker_select">';
      parent.state.crimeTypes.forEach(function(c){
        select+='<option value="'+c+'">'+c+'</option>';
      });
      select+='</select>';

      div.innerHTML = select;
      div.innerHTML += '<div class="form-check">'
  +'<input class="form-check-input" type="checkbox" value="" id="perCapita_checkbox">'
  +'<label class="form-check-label" for="perCapita_checkbox">'
  +'  per Capita'
  +'</label>'
+'</div>';
      return div;
    };

    selector.addTo(map);

    var marker_select = L.DomUtil.get("marker_select");
    var perCapita_check = L.DomUtil.get("perCapita_checkbox");

    //prevent clicks on the selector from propagating through to the map
    //(otherwise popups will close immediately after opening)
    L.DomEvent.addListener(marker_select, 'click', function(e) {
      L.DomEvent.stopPropagation(e);
    });

    L.DomEvent.addListener(marker_select, 'change', changeHandler);
    function changeHandler(e) {
      parent.setState({crimeType: e.target.value});
      parent.updateData();
    }
    L.DomEvent.addListener(perCapita_check, 'change', changePerCapitaHandler);
    function changePerCapitaHandler(e) {
      parent.setState({perCapita: e.target.checked});
      parent.updateData();
    }
    //
    var yearselector = L.control({
      position: 'topright'
    });
    yearselector.onAdd = function(map) {
  //create div container
      var div = L.DomUtil.create('div', 'ySelector');
  //create select element within container (with id, so it can be populated later)
      var select = '<select id="year_select">';
    yearList.forEach(function(c){
        select+='<option value="'+c+'">'+c+'</option>';
      });
      select+='</select>';

      div.innerHTML = select;
      return div;
    };

    yearselector.addTo(map);

    var year_select = L.DomUtil.get("year_select");

    //prevent clicks on the selector from propagating through to the map
    //(otherwise popups will close immediately after opening)
    L.DomEvent.addListener(year_select, 'click', function(e) {
      L.DomEvent.stopPropagation(e);
    });

    L.DomEvent.addListener(year_select, 'change', changeYearHandler);
    function changeYearHandler(e) {
      parent.setState({year: e.target.value});
      parent.updateData();
    }
    ////////////
    var popupControl = L.control({
      position: 'topleft'
    });
    popupControl.onAdd = function(map) {
  //create div container
      var div = L.DomUtil.create('div', 'popupchart');
      div.innerHTML = "<H3></H3>";
  //create select element within container (with id, so it can be populated later)
      return div;
    };

    popupControl.addTo(map);
  }

  communitystyle(feature) {
    return {
      fillColor: getCommunityColor(feature),
      color: 'white',
      fillOpacity: 0.6,
      weight: 0
    };
  }

  render() {
    return (
      <div id="mapUI">
        <div ref={(node) => (this._mapNode = node)} id="map" />
      </div>
    );
  }
}

function getCommunityColor(d) {
  return comm_color(d.properties.rate);
}

function crimeCount( d, name, year ){
  if( d.properties[name])
    return sum(d.properties[name], year);
  return 0;
}

function sum( obj, year ) {
  return Object.keys( obj )
               .reduce( function( sum, key ){
                 if( key.includes(year) && Number.isInteger(parseFloat( obj[key])) ){
                   return sum + parseFloat( obj[key] );
                 }
                 return sum;
               }, 0 );
}
export default Map;



/** WEBPACK FOOTER **
 ** ./src/Map.js
 **/